export { Code, type CodeProps } from './styled/code'
